<div class="app-info">
  <div class="info-title">App:</div><div class="info-data">{{appVersion}}</div>
  <div class="info-title">Service:</div><div class="info-data">{{serviceInfo.vcrVersion}}</div>
  <div class="info-title">Server:</div><div class="info-data">{{serviceInfo.hostname}}</div>
</div>
